module.exports = __webpack_public_path__ + "img/spotlight-color-on-black.4a30f68d.svg";